// NOTE: adapted from us-frontend

import * as React from 'react';

import styles from './styles/button.module.css';

export interface IProps {
  borderColor?: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  height?: number;
  noPadding?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  regressionTag?: string;
  shape?: string;
  style?: React.CSSProperties;
  testId?: string;
  type?: string;
  width?: number | string;
}

function OCButton({
  borderColor,
  children,
  className,
  disabled,
  height,
  noPadding,
  onClick,
  regressionTag,
  shape,
  style,
  testId,
  type = '',
  width,
  ...props
}: IProps) {
  if (shape === 'square' && !height && !width) {
    console.warn('A height and width should be provided for a square button');
  }

  const stylesObj = {
    ...style,
    borderColor,
    height,
    width,
  };

  const classes = [
    styles.button,
    styles[type] || '',
    shape ? styles[shape] : '',
    className || '',
    noPadding ? styles.noPadding : '',
  ].join(' ');

  return (
    <button
      className={classes}
      data-regression-tag={regressionTag}
      data-testid={testId}
      disabled={disabled}
      onClick={onClick}
      style={stylesObj}
      {...props}
    >
      {children}
    </button>
  );
}

export default OCButton;
